export default "__VITE_ASSET__CkFkSuTF__"